// routes
import { connect } from 'react-redux';
import { useEffect } from 'react';
// import firebase from 'firebase';
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { Loading } from './components/Loading';

// ----------------------------------------------------------------------

const App = ({ initAuthListener, isLoggedIn, fetchProperties, currentRole }) => {
  // const isLoggedIn = firebase.auth().currentUser !== null;
  console.log({ isLoggedIn });

  useEffect(() => {
    initAuthListener();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchProperties();
    }
  }, [isLoggedIn]);

  if (isLoggedIn === undefined) return <Loading centered />;

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      {isLoggedIn && !currentRole ? (
        <Loading centered />
      ) : (
        <Router isLoggedIn={isLoggedIn} currentRole={currentRole} />
      )}
    </ThemeConfig>
  );
};

const mapState = (state) => ({
  isLoggedIn: state.auth.isLoggedIn,
  currentRole: state.property.currentRole
});

const mapDispatch = (dispatch) => ({
  initAuthListener: dispatch.auth.authListener,
  fetchProperties: dispatch.property.fetchAllWhereImAdminOrCustodian
});

export default connect(mapState, mapDispatch)(App);
